import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem, MessageService } from 'primeng/api';
import { RequisitionTestDataService } from '../../data-services/requisitionTest.service';
import { RequisitionDataService } from '../../data-services/requisition.service';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ListboxModule } from 'primeng/listbox';

@Component({
  selector: 'app-rejectReason-dialog',
  templateUrl: './rejectReason.dialog.html',
  providers: [MessageService],
  imports: [Dialog, FormsModule, CommonModule, ListboxModule]
})
export class RejectReqasonDialogComponent implements OnInit {

  constructor(
    private requisitionService: RequisitionDataService,
    private requisitionTestService: RequisitionTestDataService,
    private messageService: MessageService) {
  }

  loading: boolean = false;
  rejectionTypes: SelectItem[] = [];
  selectedRejectionType: any = [];
  rejectionDescription: string = "";
  rejectionLevel: string = 'req';
  rejectionCommentRequired: boolean = false;

  ngOnInit() {
    this.rejectionTypes = [
      //{ label: 'Rejection', value: '0' },
      { label: 'LIT', value: '1' },
      { label: 'Past Stability', value: '2' },
      { label: 'QNS', value: '3' },
      { label: 'Order Details Missing', value: '4' },
      //{ label: 'Duplicate Serial Number', value: '5' },
      //{ label: 'Mismatched Label', value: '6' },
      { label: 'Other', value: '7' }
    ];
  }

  @Input() public accession:string  = null;
  @Input() public requisitionTestId: number = null;
  @Input() public showRejectDialog: boolean;
  @Input() public rejectDescription: string;
  @Input() public rejectReasons: any[];

  @Output() public accessionChange = new EventEmitter<string>();
  @Output() public requisitionTestIdChange = new EventEmitter<number>();
  @Output() public showRejectDialogChange = new EventEmitter<boolean>();
  @Output() public rejectDescriptionChange = new EventEmitter<string>();
  @Output() public rejectReasonsChange = new EventEmitter<any[]>();
  @Output() public onClose = new EventEmitter<boolean>();
  @Output() public onReject = new EventEmitter<boolean>();

  public rejectRequisition() {
    this.loading = true;
    if (this.accession === null) {
      this.rejectDescription = this.rejectionDescription;
      this.rejectReasons = this.selectedRejectionType;
      this.rejectDescriptionChange.emit(this.rejectDescription);
      this.rejectReasonsChange.emit(this.rejectReasons);
      this.onReject.emit(true);
      this.close(true);
      return;
    }

    if (!this.requisitionTestId) {
      //Reject Requistion
      console.log(`Rejecting requisition ${this.accession}`);
      this.requisitionService.rejectRequisition(this.accession, this.selectedRejectionType, this.rejectionDescription).subscribe((data: boolean) => {
        this.messageService.add({ severity: 'success', summary: 'Requisition Rejection ', detail: `Successful` });
        this.close(true);
      },
        (err) => {
          this.messageService.add({ severity: 'error', summary: 'Requisition Rejection ', detail: 'Failed: ' + err.error });
          this.close(false);
      });
    }
    else
    {
      //Reject Test
      console.log(`Rejecting test ${this.accession},${this.requisitionTestId}`);
      this.requisitionTestService.reject(this.accession, this.requisitionTestId, this.rejectionDescription, this.selectedRejectionType, 0).subscribe((data: boolean) => {
        this.messageService.add({ severity: 'success', summary: 'Test Rejection ', detail: `Successful` });
        this.close(true);
      },
      (err) =>
      {
        this.messageService.add({ severity: 'error', summary: 'Test Rejection ', detail: 'Failed: ' + err.error });
        this.close(false);
      });
    }
  }

  public close(value) {
    console.log(`Closing ${value}`);
    this.loading = false;
    this.accession = null;
    this.requisitionTestId = null;
    this.showRejectDialog = false;
    this.selectedRejectionType = [];
    this.rejectionCommentRequired = false;
  
    this.accessionChange.emit(this.accession);
    this.requisitionTestIdChange.emit(this.requisitionTestId);
    this.showRejectDialogChange.emit(this.showRejectDialog);
    this.onClose.emit(value);
  }
  
  public selectedRejectionTypeChange() {
    var rejectionTypeOtherSelected: boolean = false;

    for(let i = 0; i < this.selectedRejectionType.length; i++) {
      if(this.selectedRejectionType[i] == 7) {  //7 = Other (which also requires a Rejection Comment/Description)
        rejectionTypeOtherSelected = true;
        break;
      }
    }

    this.rejectionCommentRequired = rejectionTypeOtherSelected;
  }
}
